import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { init as sentryAngularInit, captureException }  from "@sentry/angular";
import { init as SentryCapacitorInit } from "@sentry/capacitor";
import { defineCustomElements } from '@ionic/pwa-elements/loader';


import build from 'src/build.json'

import { enableProdMode } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Capacitor } from '@capacitor/core';

if (environment.production) {
  enableProdMode();
}

const release = build.package + '@' + build.version
const platform = Capacitor.getPlatform()

console.log(release, platform, environment.key)

// https://stackoverflow.com/questions/49198268/how-to-overcome-loading-chunk-failed-with-angular-lazy-loaded-modules
const serverErrorsRegex = new RegExp(
  `Loading chunk|Failed to fetch|(reading 'isProxied')|NetworkError|Cstr is undefined`
);
const SENTRY_DNS = "https://b2b91ea7ba6dcc42a51f3c6100f03c65@sentry2.agrolog.io/3"
//const SENTRY_DNS = "https://10b6a895641e45dbb2c40fe3edecf3e4@sentry2.agrolog.io/2"

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(success => {
    // NOTE: disabling breadcrumbs to avoid potential out-of-memory issues
    if (Capacitor.isNativePlatform()) {
      SentryCapacitorInit({
        dsn: SENTRY_DNS,
        environment: environment.name, 
        release: release,
        dist: platform,
        tracesSampleRate: 1.0,
        maxBreadcrumbs: 0,
        ignoreErrors: [serverErrorsRegex, 'User cancelled photos app'],
        beforeSend(event, hint) {
          let error = hint.originalException
          if (error instanceof HttpErrorResponse && error.status == 0) {
            return null
          }
          return event;
        }
      }, sentryAngularInit)
    } else {
      sentryAngularInit({
        dsn: SENTRY_DNS, 
        environment: environment.name, 
        release: release,
        dist: platform,
        tracesSampleRate: 1.0,
        maxBreadcrumbs: 0,
        ignoreErrors: [serverErrorsRegex, 'User cancelled photos app'],
        beforeSend(event, hint) {
          let error = hint.originalException
          if (error instanceof HttpErrorResponse && error.status == 0) {
            return null
          }
          return event;
        }
      })
    }
  })
  .catch(error => {
    captureException(error)
    alert("Error occured: " + error.message);
    console.error(error)
  });

defineCustomElements(window);